/**
 * Grain — a faint film-grain texture over the page background, so the black
 * reads as a surface rather than a void. A static SVG noise tile (no
 * animation, no JS); sits behind content, no pointer events, hidden from
 * assistive tech. Web only. Place it right after <ScreenBackground />.
 *
 *   <ScreenBackground />
 *   <Grain />
 */
import React from 'react';
import { View } from 'react-native';
import { IS_WEB } from '../../utils/motion';
import injectCss from '../../utils/injectCss';

const NOISE = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const CSS = `
[data-grain] { position: fixed; inset: 0; pointer-events: none; opacity: 0.07; mix-blend-mode: overlay; background-image: ${NOISE}; background-size: 180px 180px; }
`;

export default function Grain() {
    if (!IS_WEB) return null;
    injectCss('grain', CSS);
    return <View dataSet={{ grain: '' }} aria-hidden accessibilityElementsHidden importantForAccessibility="no-hide-descendants" />;
}
